import { ServiceBase } from './ServiceBase';

export class Company extends ServiceBase {

}
